// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + "." + "1e435abf0ed52d7b9cbd" + ".js";
};